import flexslider from 'flexslider'; // eslint-disable-line no-unused-vars

/**
 * Stage module implementation.
 *
 * @author Daniel Koch (https://danielkoch.de)
 * @namespace Tc.Module
 * @class Stage
 * @extends Tc.Module
 */
T.Module.Stage = T.createModule({

	_configs: {
		namespace: 'slide',
		sliderAnimation: 'slide',
		imageAnimation: 'fade',
		type: null,
	},
	_selectors: {
		sliderSlideSelector: '.m-stage__bd > .m-stage__slide-item',
	},
	_eventNames: {},
	_stateClasses: {},

	start: function(resolve) {
		this.$ctx = $(this._ctx);
		this._configs.type = this.$ctx.data('type');

		this.sliderStart();

		resolve();
	},
	sync() {
		// Called when start() method of all registered modules was called.
	},

	sliderStart: function() {
		this.$ctx = $(this._ctx);

		this.$ctx.flexslider({
			namespace: this._configs.namespace,
			selector: this._selectors.sliderSlideSelector,
			directionNav: false,
			direction: 'horizontal',
			animation: this._configs.type === 'slider' ? this._configs.sliderAnimation : this._configs.imageAnimation, // eslint-disable-line max-len
			slideshow: true,
			slideshowSpeed: 12000,
			pauseOnHover: true,
			multipleKeyboard: true,
			controlNav: this._configs.type === 'slider' ? true : false,
		});
	},
});

export default T.Module.Stage;
